<template>
  <section id="home" class="hero">
    <div class="hero-bg">
      <div class="sound-waves">
        <div class="wave-bar" v-for="n in 32" :key="n"></div>
      </div>
      <div class="radio-dial">
        <div class="dial-scale">
          <div class="dial-mark" v-for="n in 16" :key="n"></div>
        </div>
        <div class="dial-indicator"></div>
      </div>
      <div class="frequency-circles">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>
    
    <div class="hero-content">
      <div class="fm-badge">87.5 - 108.0 MHz</div>
      <h1>FM <span class="highlight">Radio</span></h1>
      <h2>Premium Sound · Listen Anywhere</h2>
      <div class="description">
        <p>High-quality FM radio app for iOS and Android users</p>
        <p>Listen to global stations with crystal clear sound and smooth playback</p>
      </div>
      <div class="hero-buttons">
        <a href="#" class="btn btn-primary" @click.prevent="detectAndScrollToPlatform">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" class="download-icon-small">
            <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
          </svg>
          Download Now
        </a>
        <a href="#features" class="btn btn-secondary">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
          </svg>
          Learn More
        </a>
      </div>
      
      <div class="metrics">
        <div class="metric">
          <span class="number">5M+</span>
          <span class="label">Active Users</span>
        </div>
        <div class="divider"></div>
        <div class="metric">
          <span class="number">2000+</span>
          <span class="label">Global Stations</span>
        </div>
        <div class="divider"></div>
        <div class="metric">
          <span class="number">4.9<small>/5</small></span>
          <span class="label">App Rating</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      isIOS: false,
      isAndroid: false
    }
  },
  methods: {
    detectAndScrollToPlatform() {
      // 先检测设备类型
      this.detectDevice();
      
      // 根据设备类型滚动到对应平台
      if (this.isIOS) {
        this.scrollToiOS();
      } else if (this.isAndroid) {
        this.scrollToAndroid();
      } else {
        // 如果无法确定设备类型，默认滚动到iOS平台
        this.scrollToiOS();
      }
    },
    detectDevice() {
      try {
        if (!navigator) {
          console.warn('Navigator对象不可用');
          return;
        }
        
        // 获取用户代理字符串
        const ua = navigator.userAgent.toLowerCase();
        
        // 检测是否为iOS设备 - 使用多种方式检测
        this.isIOS = /iphone|ipad|ipod/i.test(ua) || 
                    (navigator.platform && 
                     (/iphone|ipad|ipod/.test(navigator.platform.toLowerCase()) || 
                      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)));
        
        // 检测是否为Android设备 - 多种方式检测
        this.isAndroid = /android/i.test(ua) || /linux armv|linux arm/i.test(navigator.platform);
        
        console.log(`设备检测结果: iOS=${this.isIOS}, Android=${this.isAndroid}`);
      } catch (error) {
        console.error('设备检测出错:', error);
      }
    },
    scrollToiOS() {
      try {
        const iosElement = document.getElementById('ios-platform');
        if (iosElement) {
          iosElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          iosElement.classList.add('highlight-platform');
          
          setTimeout(() => {
            iosElement.classList.remove('highlight-platform');
          }, 3000);
        } else {
          // 如果找不到iOS元素，滚动到下载区域
          const downloadSection = document.getElementById('download');
          if (downloadSection) {
            downloadSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      } catch (error) {
        console.error('iOS平台滚动出错:', error);
      }
    },
    scrollToAndroid() {
      try {
        const androidElement = document.getElementById('android-platform');
        if (androidElement) {
          androidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          androidElement.classList.add('highlight-platform');
          
          setTimeout(() => {
            androidElement.classList.remove('highlight-platform');
          }, 3000);
        } else {
          // 如果找不到Android元素，滚动到下载区域
          const downloadSection = document.getElementById('download');
          if (downloadSection) {
            downloadSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      } catch (error) {
        console.error('Android平台滚动出错:', error);
      }
    }
  }
}
</script>

<style scoped>
.hero {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 0 6rem;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.98) 0%, rgba(23, 37, 84, 0.95) 100%);
  z-index: -1;
}

.sound-waves {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding: 0 10%;
}

.wave-bar {
  width: 3px;
  height: 15px;
  background-color: rgba(59, 130, 246, 0.4);
  border-radius: 3px;
  animation: sound-wave 1.5s infinite ease;
  animation-delay: calc(var(--delay, 0) * 0.05s);
}

.wave-bar:nth-child(odd) {
  --delay: attr(n);
  animation-duration: 1.7s;
}

.wave-bar:nth-child(even) {
  --delay: attr(n);
  animation-duration: 1.9s;
}

.wave-bar:nth-child(1) { height: 40px; animation-delay: 0.1s; }
.wave-bar:nth-child(2) { height: 25px; animation-delay: 0.2s; }
.wave-bar:nth-child(3) { height: 60px; animation-delay: 0.3s; }
.wave-bar:nth-child(4) { height: 35px; animation-delay: 0.4s; }
.wave-bar:nth-child(5) { height: 50px; animation-delay: 0.5s; }
.wave-bar:nth-child(6) { height: 20px; animation-delay: 0.6s; }
.wave-bar:nth-child(7) { height: 45px; animation-delay: 0.7s; }
.wave-bar:nth-child(8) { height: 30px; animation-delay: 0.8s; }
.wave-bar:nth-child(9) { height: 70px; animation-delay: 0.9s; }
.wave-bar:nth-child(10) { height: 20px; animation-delay: 1.0s; }
.wave-bar:nth-child(11) { height: 55px; animation-delay: 0.7s; }
.wave-bar:nth-child(12) { height: 25px; animation-delay: 0.8s; }
.wave-bar:nth-child(13) { height: 45px; animation-delay: 0.9s; }
.wave-bar:nth-child(14) { height: 30px; animation-delay: 1.0s; }
.wave-bar:nth-child(15) { height: 65px; animation-delay: 0.5s; }
.wave-bar:nth-child(16) { height: 20px; animation-delay: 0.6s; }
.wave-bar:nth-child(17) { height: 40px; animation-delay: 0.3s; }
.wave-bar:nth-child(18) { height: 25px; animation-delay: 0.4s; }
.wave-bar:nth-child(19) { height: 60px; animation-delay: 0.5s; }
.wave-bar:nth-child(20) { height: 35px; animation-delay: 0.6s; }
.wave-bar:nth-child(21) { height: 50px; animation-delay: 0.7s; }
.wave-bar:nth-child(22) { height: 20px; animation-delay: 0.8s; }
.wave-bar:nth-child(23) { height: 45px; animation-delay: 0.9s; }
.wave-bar:nth-child(24) { height: 30px; animation-delay: 1.0s; }
.wave-bar:nth-child(25) { height: 70px; animation-delay: 0.1s; }
.wave-bar:nth-child(26) { height: 20px; animation-delay: 0.2s; }
.wave-bar:nth-child(27) { height: 55px; animation-delay: 0.3s; }
.wave-bar:nth-child(28) { height: 25px; animation-delay: 0.4s; }
.wave-bar:nth-child(29) { height: 45px; animation-delay: 0.5s; }
.wave-bar:nth-child(30) { height: 30px; animation-delay: 0.6s; }
.wave-bar:nth-child(31) { height: 65px; animation-delay: 0.7s; }
.wave-bar:nth-child(32) { height: 20px; animation-delay: 0.8s; }

@keyframes sound-wave {
  0%, 100% {
    height: calc(var(--height, 30px) * 0.8);
    opacity: 0.4;
  }
  50% {
    height: var(--height, 30px);
    opacity: 0.7;
  }
}

.radio-dial {
  position: absolute;
  top: 15%;
  right: 10%;
  width: 220px;
  height: 45px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  overflow: hidden;
  transform: rotate(-10deg);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dial-scale {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  height: 100%;
  align-items: center;
}

.dial-mark {
  width: 1px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.4);
}

.dial-mark:nth-child(odd) {
  height: 16px;
  width: 2px;
  background-color: rgba(255, 255, 255, 0.6);
}

.dial-indicator {
  position: absolute;
  top: 0;
  left: 48%;
  width: 4px;
  height: 100%;
  background-color: #3b82f6;
  box-shadow: 0 0 10px #3b82f6, 0 0 20px #3b82f6;
  animation: dial-move 8s infinite alternate ease-in-out;
}

@keyframes dial-move {
  0% {
    left: 30%;
  }
  100% {
    left: 60%;
  }
}

.frequency-circles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.06;
  background: radial-gradient(circle, #3b82f6 0%, transparent 70%);
}

.circle-1 {
  top: -20%;
  left: -10%;
  width: 60vw;
  height: 60vw;
  animation: pulse 15s infinite alternate;
}

.circle-2 {
  bottom: -30%;
  right: -20%;
  width: 80vw;
  height: 80vw;
  animation: pulse 20s infinite alternate-reverse;
}

.circle-3 {
  top: 20%;
  right: 20%;
  width: 30vw;
  height: 30vw;
  animation: pulse 10s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.06;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.09;
  }
  100% {
    transform: scale(1);
    opacity: 0.06;
  }
}

.hero-content {
  width: 100%;
  max-width: 800px;
  color: white;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 0 1.5rem;
  animation: fade-in 1s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fm-badge {
  display: inline-block;
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  padding: 0.6rem 1.8rem;
  border-radius: 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 2.5rem;
  letter-spacing: 1px;
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  animation: float 3s infinite ease-in-out;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.hero-content h1 {
  font-size: 5rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  letter-spacing: -1px;
  line-height: 1.1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.highlight {
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 3px;
  opacity: 0.5;
}

.hero-content h2 {
  font-size: 1.9rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2.2rem;
  letter-spacing: 2px;
}

.description {
  margin-bottom: 3rem;
}

.description p {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  margin-bottom: 0.75rem;
}

.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 3.5rem;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1.1rem 2.2rem;
  border-radius: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 1.15rem;
  letter-spacing: 0.5px;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  box-shadow: 0 12px 25px rgba(37, 99, 235, 0.35), 0 0 0 1px rgba(59, 130, 246, 0.5);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(-5px);
  box-shadow: 0 18px 35px rgba(37, 99, 235, 0.45), 0 0 0 1px rgba(59, 130, 246, 0.6);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  backdrop-filter: blur(15px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.18);
  transform: translateY(-5px);
  box-shadow: 0 18px 35px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.metrics {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(15px);
  padding: 1.8rem 2.5rem;
  border-radius: 1.2rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transform: translateY(0);
  transition: all 0.3s ease;
}

.metrics:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.1);
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.2rem;
}

.number {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.3rem;
  background: linear-gradient(135deg, #fff, #dbeafe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.number small {
  font-size: 1.1rem;
  opacity: 0.8;
  font-weight: 400;
}

.label {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.divider {
  width: 1px;
  height: 45px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.05));
}

.download-icon-small {
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .hero {
    padding: 7rem 0 5rem;
  }
  
  .hero-content h1 {
    font-size: 4rem;
  }
  
  .hero-content h2 {
    font-size: 1.6rem;
  }
  
  .radio-dial {
    top: 10%;
    right: 5%;
    width: 180px;
    height: 40px;
  }
}

@media (max-width: 640px) {
  .hero {
    padding: 6rem 0 4rem;
  }
  
  .hero-content h1 {
    font-size: 3rem;
  }
  
  .hero-content h2 {
    font-size: 1.4rem;
    letter-spacing: 1px;
  }
  
  .description p {
    font-size: 1.1rem;
  }
  
  .hero-buttons {
    flex-direction: column;
    gap: 1rem;
  }
  
  .metrics {
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
  }
  
  .divider {
    width: 80%;
    height: 1px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.05));
  }
  
  .sound-waves {
    padding: 0 5%;
    gap: 2px;
  }
  
  .radio-dial {
    display: none;
  }
  
  .fm-badge {
    font-size: 0.95rem;
    padding: 0.5rem 1.5rem;
  }
}
</style> 